import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {toJS} from "mobx";
import isArray from "lodash/isArray";
import endsWith from "lodash/endsWith";
import useField from "../../hooks/use-field";
import SelectOptions from "./SelectOptions";

function Select(props) {

    const field = useField(props);

    let value = field.value;

    if (!props.multiple) {
        if (isArray(toJS(value))) {
            value = (value.length === 1) ? value[0] : '';
        }
    } else {
        if (isArray(toJS(value))) {
            value = toJS(value);
        } else if (!value) {
            value = [];
        } else {
            value = [value];
        }
    }

    const fieldName = (props.multiple === true) ?
        (endsWith(field.name, '[]') ? field.name : field.name + '[]')
        : field.name;

    return field.wrap(() => (
        <select id={field.id} name={fieldName}
                value={value}
                multiple={props.multiple === true ? 'multiple' : null}
                onBlur={field.onBlur}
                onFocus={field.onFocus}
                onChange={e => {

                    let value = Array.from(e.target.selectedOptions, option => option.value);

                    if(props.multiple === false) {
                        value = value[0] || null;
                    }

                    field.onChange(value);
                }}
                disabled={props.disabled}>
            {(!props.placeholder) ? null : (<option value="" disabled={props.required}>{props.placeholder}</option>)}
            <SelectOptions options={field.options}/>
        </select>
    ));
}

Select.defaultProps = {
    ...useField.defaultProps,
    disabled: false,
    multiple: false,
    placeholder: "",
}

Select.propTypes = {
    ...useField.propTypes,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
}

export default observer(Select);
